import React from 'react';
import styles from './AwardBlock.css';
import SimpleAwardBlock from './SimpleAwardBlock';
import BiggestAwardBlock from './BiggestAwardBlock';
import MultiAwardBlock from './MultiAwardBlock';

export const WinnerBadge = ({ winner, className }) => (
  <div className={`${styles.winnerBadge} ${className}`}>
    <div className={styles.winnerLabel}>得獎者</div>
    <div className={styles.winner}>{winner}</div>
  </div>
);

const AwardBlock = ({ isMulti, isBiggest, ...props }) => {
  if (isBiggest) {
    return (<BiggestAwardBlock {...props} />);
  } else if (isMulti) {
    return (<MultiAwardBlock {...props} />);
  }

  return (<SimpleAwardBlock {...props} isLong={props.isLong && !props.hasWinner} />);
};

export default AwardBlock;



// WEBPACK FOOTER //
// ./src/components/AwardBlock/index.js